import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#697077",
      d: "M10 1.667a8.333 8.333 0 1 1 0 16.666 8.333 8.333 0 0 1 0-16.666zm5.098 12.627a6.635 6.635 0 0 0 1.515-3.46h-4.709l3.194 3.46zm-4.264-5.127h5.78a6.67 6.67 0 0 0-5.78-5.78v5.78zm-7.5.833A6.67 6.67 0 0 0 10 16.667a6.634 6.634 0 0 0 3.873-1.243l-4.485-4.858A.835.835 0 0 1 9.167 10V3.386A6.67 6.67 0 0 0 3.333 10z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "chart-pie"}) } }